import React, { useEffect, useState } from 'react';
import AuthLayout from '../auth-layout';
import useLetsGetStartedContext from 'contexts/lets-get-started.context';
import FileUploaderWithCropTool from 'components/base/file-uploader/crop-tool';
import { Input } from '@cokitchen/cokitchen-components';
import AddressInput from 'components/base/address-input';

const CompanyDetails = () => {
  const { companyInfoFormData, setCompanyInfoFormData, setDisabled } = useLetsGetStartedContext();
  const [companyLogo, setCompanyLogo] = useState<string[]>([]);

  const formData = [
    {
      label: 'Company name',
      name: 'company_name',
      placeholder: 'Donatus Globus ltd',
      value: companyInfoFormData.company_name
    },
    {
      label: 'Company mail',
      name: 'company_email',
      placeholder: 'donatusglobusltd@yahoo.com',
      value: companyInfoFormData.company_email
    },
    {
      type: 'address',
      label: 'Company address',
      name: 'company_address',
      placeholder: 'City',
      value: companyInfoFormData.company_address
    },
    {
      label: 'CAC number',
      name: 'cac_number',
      placeholder: 'RC1011242',
      value: companyInfoFormData.cac_number,
      length: 14
    }
  ];
  const updateFormData = (name: string, value: string) => {
    setCompanyInfoFormData({ ...companyInfoFormData, [name]: value });
  };

  useEffect(() => {
    setCompanyInfoFormData({ ...companyInfoFormData, company_logo: companyLogo[0] });
  }, [companyLogo]);

  useEffect(() => {
    const { company_name, company_email, company_address, cac_number } = companyInfoFormData;
    if (company_name && company_email && company_address && cac_number) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [companyInfoFormData]);
  return (
    <AuthLayout
      title={`Let's get you started`}
      subtitle='Ensure to provide correct details for all steps'
      onConfirmText='Continue'
      hideButton>
      <div className='flex flex-col gap-7'>
        {formData?.map(({ type, label, placeholder, name, value, length }, index) =>
          type === 'address' ? (
            <AddressInput
              key={index}
              label={label}
              placeholder={placeholder}
              value={value}
              onChange={(address) => updateFormData(name, address)}
            />
          ) : (
            <Input
              design='bordered'
              key={index}
              label={label}
              placeholder={placeholder}
              value={value}
              onChange={(e) => updateFormData(name, e.target.value)}
              maxLength={length}
            />
          )
        )}
      </div>
      <p className='mt-7 mb-[6px] text-[#2E3031] font-medium'>Company logo</p>
      <FileUploaderWithCropTool
        aspectRatio={2.24}
        fileUrls={companyLogo}
        setFileUrls={setCompanyLogo}
      />
    </AuthLayout>
  );
};

export default CompanyDetails;
